import React from "react";
import LeftIcon from "../assets/left-arrow.png";
import RightIcon from "../assets/right-arrow.png";

export default function Footer({
  prev,
  next,
  isPrevEnable,
  isNextEnablen,
  back,
  isEditMode,
}) {
  return (
    <>
      <div className={`footer-container ${isEditMode ? "edit-mode" : ""}`}>
        <div className="footer-text">
          <p onClick={back.action}>{back.text}</p>
        </div>
        <div className="navigation-icons-container">
          <div
            onClick={() => {
              isPrevEnable && prev();
            }}
            className={`navigation-icon ${!isPrevEnable && "disabled"}`}
          >
            {!isEditMode ? <p>PREV</p> : null}
            <div className="icon">
              <img alt="previous icon" src={LeftIcon} />
            </div>
          </div>
          <div
            onClick={() => {
              isNextEnablen && next();
            }}
            className={`navigation-icon ${!isNextEnablen && "disabled"}`}
          >
            {!isEditMode ? <p>NEXT</p> : null}
            <div className="icon">
              <img alt="next icon" src={RightIcon} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
